import { Methods } from '@newview/infrastructure';
import {BasicDataBaseApi} from "./BasicDataBaseApi";


export class WorkFlowTaskApi extends BasicDataBaseApi {

    public get ControllerName(): any {
        return 'businessworkflowtask';
    }

    /**
     * 获取用户所对应的待办任务
     * @param params
     */
    public getWorkFlowPendTask(userId:number,current:number,size:number, flowIds?:any){
        return this.send({userId: userId,current:current,size:size, flowIds},"workFlowPendTask",Methods.GET);
    }

    /**
     * 流程通过接口
     * @param params 通过参数
     * @returns 
     */
    public workFlowNext(params){
        return this.send(params,"workFlowNext",Methods.POST);
    }
    /**
     * 流程驳回接口
     * @param params 通过参数
     * @returns 
     */
     public workFlowReject(params){
        return this.send(params,"workFlowReject",Methods.POST);
    }
    /**
     * 流程处理步骤图
     * @param wfId 
     * @param biid 
     * @returns 
     */
    public getStepRecord(wfId,biid){
        return this.send({wfId: wfId,biid: biid},"getStepRecord",Methods.GET);
    }
    /**
     * wfId
     * subSystemId
     * userId
     * biid
     * 流程初始化
     * @param params 
     * @returns 
     */
    public workFlowInit(params){
        return this.send(params,"workFlowInit",Methods.POST);
    }

    /**
     * 初始化获取流程第二节点是否指定下一步执行人
     * @param params
     */
    public getNextStepIsAssign(params){
        return this.send(params,"getNextStepIsAssign",Methods.GET);
    }

    /**
     * 根据业务id获取流程步骤
     * @param params 
     * @returns 
     */
    public getTaskList(params){
        return this.send(params,"getTaskList",Methods.GET);
    }

     /**
     * 获取流程下一节点是否退回指定节点
     * @param params
     */
      public getBackOffData(params){
        return this.send(params,"getBackOffData",Methods.GET);
    }
    /**
     * 获取用户已审批的业务
     * @param params
     */
     public getWorkFlowYetTask(userId,current,size, flowIds){
        return this.send({userId: userId,current:current,size:size, flowIds: flowIds},"getWorkFlowYetTask",Methods.GET);
    }


}